import { render } from "./AdminPartnerApplications.vue?vue&type=template&id=8ba5196e&scoped=true"
import script from "./AdminPartnerApplications.vue?vue&type=script&lang=js"
export * from "./AdminPartnerApplications.vue?vue&type=script&lang=js"

import "./AdminPartnerApplications.vue?vue&type=style&index=0&id=8ba5196e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba5196e"]])

export default __exports__